module.controller('printDirectDepositCtrl', ['$scope', '$rootScope', '$stateParams', '$http', 'Session', 'baseURI', 'brandService', 'accountService', function ($scope, $rootScope, $stateParams, $http, Session, baseURI, brandService, accountService){
  var url = baseURI + 'directdeposit';

  $scope.accountNumber = $stateParams.AccountNumber;
  $scope.routing = $stateParams.Routing;

  if (!$stateParams.brand) {
    $scope.brand = brandService.getBrand(Session.getBrand());
  } else {
    $scope.brand = brandService.getBrand($stateParams.brand);
  }

  $scope.bank = $scope.brand.issuer.bank;

  var getDirectDepositInfo = function(){
    $scope.loading = true;
    $http.get(url, {cache: true}).then(function (resp){
      var data = resp.data;
      $scope.loading = false;
      $scope.accountNumber = data.Data.Account;
      $scope.routing = data.Data.Routing;
      setTimeout(function(){
        window.print();
      }, 1000);
    }).catch(function (error){
      console.log('err', error);
      $scope.loading = false;
    });
  };

  getDirectDepositInfo();

}]);
